"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var debounce_1 = __importDefault(require("lodash/debounce"));
var react_1 = __importStar(require("react"));
var recharts_1 = require("recharts");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var Types_1 = require("../Types");
var BarTooltipContainer_1 = __importDefault(require("./BarTooltipContainer"));
var DefaultBarShapes_1 = require("../Common/DefaultBarShapes");
var Colors_1 = require("@CommonFrontend/Styles/Colors");
var MAX_BAR_WIDTH = 160;
var renderCustomisedLabel = function (labelProps, data, CustomisedComponent) {
    var _a;
    var value = labelProps.value, index = labelProps.index;
    var displayValue = (_a = data[index].label) !== null && _a !== void 0 ? _a : value.reduce(function (acc, next) { return acc + next; }, 0);
    return react_1.default.createElement(CustomisedComponent, __assign({}, labelProps, { displayValue: displayValue }));
};
var renderCustomisedTooltip = function (tooltipData, chartRef) {
    var _a = tooltipData || {}, tooltipProps = _a.tooltipProps, show = _a.show;
    var children = (tooltipData === null || tooltipData === void 0 ? void 0 : tooltipData.tooltipComponent) && tooltipProps ? react_1.default.createElement(tooltipData.tooltipComponent, __assign({}, tooltipProps)) : undefined;
    return (react_1.default.createElement(BarTooltipContainer_1.default, { show: Boolean(show), tooltipProps: tooltipProps, chartRef: chartRef }, children));
};
var renderCustomisedTick = function (tickProps, data, customisationTickProps) {
    var CustomisedComponent = customisationTickProps.component, formatter = customisationTickProps.formatter;
    var index = tickProps.index;
    return react_1.default.createElement(CustomisedComponent, __assign({}, tickProps, { data: data[index], formatter: formatter }));
};
var statusToColor = function (activeStatus) {
    var statusColourMap = {
        DRAFT: "#D1D7E2",
        LIVE: "#FFAB6F",
        ACCEPTED: "#81EDEC",
        DECLINED: "#EF6E85",
    };
    var colour = statusColourMap[activeStatus.toUpperCase()];
    return colour || statusColourMap.DRAFT;
};
var renderCustomisedShape = function (props, CustomisedComponent, activeStatus) {
    return (react_1.default.createElement(CustomisedComponent, __assign({}, props, { payload: __assign(__assign({}, props.payload), { color: statusToColor(props.xAxisName) }), activeStatus: activeStatus })));
};
function StackedBarChart(_a) {
    var _b, _c, _d;
    var data = _a.data, _e = _a.config, config = _e === void 0 ? {} : _e, _f = _a.customisations, customisations = _f === void 0 ? {} : _f;
    var _g = __read((0, react_1.useState)(undefined), 2), tooltipData = _g[0], setTooltipData = _g[1];
    var chartRef = (0, react_1.useRef)(null);
    var customisedTick = customisations.tick
        ?
            function (props) { return renderCustomisedTick(props, data, customisations.tick); }
        : undefined;
    var customisedLabel = customisations.label
        ?
            function (props) { return renderCustomisedLabel(props, data, customisations.label); }
        : undefined;
    var onMouseEnterHandler = (0, debounce_1.default)(function (props, activeIndex, tooltipComponent) {
        var _a;
        if (!tooltipComponent)
            return;
        var newTooltipData = {
            tooltipProps: props,
            tooltipComponent: tooltipComponent,
            show: true,
            activeIndex: activeIndex,
            activeSegment: (_a = props.tooltipPayload[0]) === null || _a === void 0 ? void 0 : _a.dataKey,
        };
        setTooltipData(newTooltipData);
    }, kaleidoscope_1.AnimationDuration.Medium + 50, { leading: true, trailing: false });
    var onMouseLeaveHandler = function (_props) {
        if (tooltipData)
            setTooltipData(__assign(__assign({}, tooltipData), { show: false }));
    };
    return (react_1.default.createElement("div", { className: "chart__container", ref: chartRef },
        react_1.default.createElement(recharts_1.ResponsiveContainer, { width: "100%", height: "100%" },
            react_1.default.createElement(recharts_1.BarChart, { data: data },
                react_1.default.createElement(recharts_1.XAxis, { dataKey: "xAxisName", axisLine: false, tickLine: false, height: (_b = customisations.tick) === null || _b === void 0 ? void 0 : _b.height, tick: customisedTick }),
                react_1.default.createElement(recharts_1.YAxis, { hide: true, domain: [0, function (dataMax) { return dataMax * 1.15; }] }),
                react_1.default.createElement(recharts_1.Bar, { className: "test", isAnimationActive: false, barSize: config.barWidth || MAX_BAR_WIDTH, dataKey: "data[1]", stackId: "a", fill: Colors_1.ColorPalette.Purple, shape: ((_c = customisations.shape) === null || _c === void 0 ? void 0 : _c.bottom)
                        ?
                            function (props) {
                                var _a;
                                return renderCustomisedShape(props, (_a = customisations.shape) === null || _a === void 0 ? void 0 : _a.bottom, getActiveStatusForBar(tooltipData, props.index, "data[1]"));
                            }
                        :
                            function (props) { return (react_1.default.createElement(DefaultBarShapes_1.DefaultBarShapeWithGap, { shapeProps: props, activeStatus: getActiveStatusForBar(tooltipData, props.index, "data[1]"), opacity: 0.5 })); }, onMouseEnter: function (props, activeIndex) { var _a; return onMouseEnterHandler(props, activeIndex, (_a = customisations.tooltip) === null || _a === void 0 ? void 0 : _a.bottom); }, onMouseLeave: onMouseLeaveHandler }),
                react_1.default.createElement(recharts_1.Bar, { isAnimationActive: false, barSize: config.barWidth || MAX_BAR_WIDTH, dataKey: "data[0]", stackId: "a", radius: [8, 8, 0, 0], shape: ((_d = customisations.shape) === null || _d === void 0 ? void 0 : _d.top)
                        ?
                            function (props) {
                                var _a;
                                return renderCustomisedShape(props, (_a = customisations.shape) === null || _a === void 0 ? void 0 : _a.top, getActiveStatusForBar(tooltipData, props.index, "data[0]"));
                            }
                        : undefined, onMouseEnter: function (props, activeIndex) { var _a; return onMouseEnterHandler(props, activeIndex, (_a = customisations.tooltip) === null || _a === void 0 ? void 0 : _a.top); }, onMouseLeave: onMouseLeaveHandler },
                    customisations.label && react_1.default.createElement(recharts_1.LabelList, { dataKey: "data", position: "top", content: customisedLabel }),
                    data.map(function (cellData, index) {
                        return (0, DefaultBarShapes_1.DefaultBarShape)({ data: cellData, activeStatus: getActiveStatusForBar(tooltipData, index, "data[0]") });
                    })))),
        Boolean(customisations.tooltip) && renderCustomisedTooltip(tooltipData, chartRef)));
}
function getActiveStatusForBar(tooltipData, cellIndex, dataKey) {
    if (!tooltipData || !tooltipData.show)
        return Types_1.BarShapeActiveStatus.Standard;
    if (tooltipData.activeIndex === cellIndex && tooltipData.activeSegment === dataKey)
        return Types_1.BarShapeActiveStatus.Active;
    if (tooltipData.activeIndex === cellIndex && tooltipData.activeSegment != dataKey)
        return Types_1.BarShapeActiveStatus.Inactive;
    return Types_1.BarShapeActiveStatus.Standard;
}
exports.default = StackedBarChart;
